// Vendor
import { FC } from 'react';
import styled from 'styled-components/macro';

// Components
import { Row } from 'src/components/atoms/Row';
import { Icon } from 'src/components/atoms/Icon';
import { ToolTip } from 'src/components/atoms/ToolTip';
import { ToolTipDirection } from 'src/components/atoms/ToolTip/ToolTip';
import Button, { ButtonColor, ButtonVariant } from 'src/components/atoms/Button';
import Text, { TextAlign, TextColor, TextVariant } from 'src/components/atoms/Text';

// Hooks
import { useCopyToClipboard } from 'src/hooks';

const StyledButton = styled(Button)`
  height: 100%;
  padding: 0;
  display: flex;
  align-items: flex-start;
`;

const StyledText = styled(Text)`
  margin-right: 8px;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const CopyableField: FC<{
  title: string;
  content: string;
  contentColor?: TextColor;
}> = ({ title, content, contentColor }) => {
  const { copy } = useCopyToClipboard();

  return (
    <Row gap={1}>
      <Row.Col size={3}>
        <Text align={TextAlign.right} color={TextColor.gray700} variant={TextVariant.small} isBold>
          {title}
        </Text>
      </Row.Col>
      <Row.Col size={9} style={{ display: 'flex' }}>
        <StyledButton
          variant={ButtonVariant.ghost}
          color={ButtonColor.tertiary}
          name="CopyEntryMetadataButton"
          onClick={() => copy(content, 'Entry ID copied to clipboard')}
        >
          <StyledText color={contentColor || TextColor.gray700} variant={TextVariant.small}>
            {content}
          </StyledText>
          <ToolTip content="Copy to clipboard" direction={ToolTipDirection.top}>
            <Icon icon="filterNone" />
          </ToolTip>
        </StyledButton>
      </Row.Col>
    </Row>
  );
};

export default CopyableField;
